import React from 'react';
import { observer } from 'mobx-react-lite';
import { Undo, Redo } from 'lucide-react';
import { useHistory } from '@/hooks/useHistory';
import styles from './UndoRedoControls.module.css';

export const UndoRedoControls: React.FC = observer(() => {
  const { canUndo, canRedo, undo, redo } = useHistory();

  return (
    <div className={styles['container']}>
      <button
        className={`${styles['button']} ${!canUndo ? styles['disabled'] : ''}`}
        onClick={undo}
        disabled={!canUndo}
        title="Undo (Ctrl+Z)"
        aria-label="Undo last action"
      >
        <Undo className={styles['icon']} />
        <span className={styles['shortcut']}>Ctrl+Z</span>
      </button>

      <button
        className={`${styles['button']} ${!canRedo ? styles['disabled'] : ''}`}
        onClick={redo}
        disabled={!canRedo}
        title="Redo (Ctrl+Y)"
        aria-label="Redo last action"
      >
        <Redo className={styles['icon']} />
        <span className={styles['shortcut']}>Ctrl+Y</span>
      </button>
    </div>
  );
}); 